import { render, staticRenderFns } from "./SC.vue?vue&type=template&id=6c824244&scoped=true&"
import script from "./SC.vue?vue&type=script&lang=js&"
export * from "./SC.vue?vue&type=script&lang=js&"
import style0 from "./SC.vue?vue&type=style&index=0&id=6c824244&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c824244",
  null
  
)

export default component.exports